import { Db, Collection } from "mongodb";
import { MongoQuery } from "./MongoQuery";
import { MongoCollection } from "../MongoCollection";

export class MongoQuerySingle<T extends MongoCollection> extends MongoQuery<T>
{

    
    then<TResult1 = T, TResult2 = never>(onfulfilled?: ((value: T) => TResult1 | PromiseLike<TResult1>) | undefined | null, onrejected?: ((reason: any) => TResult2 | PromiseLike<TResult2>) | undefined | null): Promise<T>
    {
        return this.exec().then( onfulfilled, onrejected ) as any;
    }

    
    catch<TResult = never>(onrejected?: ((reason: any) => TResult | PromiseLike<TResult>) | undefined | null): Promise<T>
    {
        return this.exec().catch(onrejected) as any;
      }
    
	exec(): Promise<T>
	{

		return new Promise<T>( (resolve, reject) => {
            //this.limit(1);
            this.cursor({ batchSize : 1 });
			let query: Promise<any> = this.cursor().toArray().then((data:any) => {
				if(this.isLean || !data)
				{
					return resolve(data[0]);
				}
				let instance:any = this.collection.constructCollection((this.collection as any));
				instance.hydrate(data[0]);
				resolve(instance);
			}).catch( reject );
		});
	}
};